import React, { useState } from "react";
import { RefinementList, Panel } from "react-instantsearch-dom";
import * as styles from "./ArboretumSearchResults.module.css";

interface Props {
  header: string;
  attribute: string;
  tooltip?: string;
  open?: boolean;
}

export const CollapsiblePanel: React.FC<Props> = ({
  header,
  attribute,
  tooltip,
  open,
  ...props
}) => {
  const [isOpen, setIsOpen] = useState(open);
  const panelClasses = [styles.panel];
  isOpen && panelClasses.push(styles.open);

  const sortItems = (items: { label: string }[]) => {
    return items.sort((a: any, b: any) => {
      if (a.label > b.label) return 1;
      if (a.label < b.label) return -1;
      return 0;
    });
  };

  const renderHeader = () => {
    return (
      <button onClick={() => setIsOpen(!isOpen)} className={styles.panelButton}>
        <div className={styles.label}>
          <div className={styles.text}>{header}</div>
          {tooltip && (
            <div className={styles.tooltip}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                data-name="info button"
              >
                <path
                  fill="#03c18a"
                  d="M9 18a9 9 0 1 1 9-9 9 9 0 0 1-9 9ZM9 1.2A7.8 7.8 0 1 0 16.8 9 7.8 7.8 0 0 0 9 1.2Z"
                  data-name="Path 6"
                />
                <path fill="#03c18a" d="M8 9h2v5H8z" data-name="Rectangle 18" />
                <path
                  fill="#03c18a"
                  d="M9 6.769a1.5 1.5 0 1 1 1.5-1.5 1.5 1.5 0 0 1-1.5 1.5Zm0-1.5Z"
                  data-name="Path 7"
                />
              </svg>
              <div className={styles.tooltipText}>{tooltip}</div>
            </div>
          )}
        </div>
        <svg
          className={styles.caret}
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 19.661 11.153"
        >
          <path
            fill="rgba(31,92,64,0.99)"
            d="M1.323 0h17.015a1.32 1.32 0 0 1 .932 2.255l-8.5 8.511a1.325 1.325 0 0 1-1.871 0l-8.5-8.511A1.32 1.32 0 0 1 1.323 0Z"
            data-name="8541675_caret_down_icon"
          />
        </svg>
      </button>
    );
  };

  return (
    <Panel header={renderHeader()} className={panelClasses.join(" ")}>
      <RefinementList
        attribute={attribute}
        limit={50}
        transformItems={sortItems}
      ></RefinementList>
    </Panel>
  );
};
